import { render } from "./SharePostModal.vue?vue&type=template&id=26d19b6a&scoped=true"
import script from "./SharePostModal.vue?vue&type=script&lang=js"
export * from "./SharePostModal.vue?vue&type=script&lang=js"

import "./SharePostModal.vue?vue&type=style&index=0&id=26d19b6a&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d19b6a"]])

export default __exports__